import { Expose } from 'class-transformer';

export class NotificationMessageDto {
  @Expose()
  uuid: string;

  @Expose()
  message: string;

  @Expose()
  group: string;
}
